import cn from 'classnames';
import type { ReactNode } from 'react';
import { PartitionIcon } from '@shared/assets/icons/partition-icon.tsx';
import { Partition } from '@src/api/common.ts';
import * as st from './styles.module.scss';

interface Props {
  partitions: Partition[];
  onPartitionClick?: (partitionId: number) => void;
  getPartitionOnClick?: (p: Partition) => void;
  icon?: ReactNode;
  selectedPartitionId?: number;
}

export const PartitionsList: React.FC<Props> = ({
  partitions,
  selectedPartitionId,
  onPartitionClick,
  icon = <PartitionIcon />,
  getPartitionOnClick,
}) => {
  return (
    <>
      <ul className={st.list}>
        {partitions?.map((p) => {
          const isLargeTitle = p.name.length > 25;
          return (
            <li
              className={cn(
                st.item,
                p.id === selectedPartitionId && st.active,
                isLargeTitle && st.largeTitle
              )}
              onClick={() => {
                getPartitionOnClick && getPartitionOnClick(p);
                onPartitionClick && onPartitionClick(p.id);
              }}
              key={p.id}
            >
              <span className={st.icon}>{icon}</span>
              <span className={st.verbName}>{p.name}</span>
            </li>
          );
        })}
      </ul>
    </>
  );
};
